import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "../Logo";

const LINKS = [
  { href: "/careers#openings", label: "Openings" },
  { href: "/careers#talent-pool", label: "Drop your CV" },
  { href: "/#about", label: "About PLUK" },
];

export const CareersNav = () => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#0a0c0e]/85 backdrop-blur-xl" data-testid="careers-header">
    <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8 lg:px-12">
      <Link to="/" data-testid="careers-nav-logo" aria-label="PLUK HR home"><Logo /></Link>
      <nav className="hidden md:flex items-center gap-9">
        {LINKS.map((l) => (
          <a key={l.href} href={l.href} className="text-sm text-zinc-300 hover:text-white transition-colors" data-testid={`careers-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
            {l.label}
          </a>
        ))}
      </nav>
      <a href="/#mandate" className="group inline-flex items-center gap-2 rounded-full border border-emerald-400/50 px-4 py-2 text-sm text-emerald-200 hover:bg-emerald-500 hover:text-[#0a0c0e] transition-colors" data-testid="careers-nav-employers">
        For employers <ArrowUpRight className="h-4 w-4" />
      </a>
    </div>
  </header>
);
